import { CustomerServicePlan } from "@app/project/model/customer-service-plan";
import { DataAction, DataErrorAction, DataSuccessAction } from "@app/shared/resources/data-actions";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { DataServiceError } from "@app/shared/services/data-service-error";

export enum ActionTypes {
    getCustomerServicePlan = "[CustomerServicePlan Management] GetCustomerServicePlan",
    getCustomerServicePlanSuccess = "[CustomerServicePlan Management] GetCustomerServicePlanSuccess",
    getCustomerServicePlanFailure = "[CustomerServicePlan Management] GetCustomerServicePlanFailure",
    // getCustomerServicePlans="[CustomerServicePlan Management] GetCustomerServicePlans",
    // getCustomerServicePlansSuccess="[CustomerServicePlan Management] GetCustomerServicePlansSuccess",
    // getCustomerServicePlansFailure="[CustomerServicePlan Management] GetCustomerServicePlansFailure"
}

type CustomerServicePlanAction = DataAction<
    number | CustomerServicePlan | ClareDbCollection<CustomerServicePlan>
>;
type CustomerServicePlanSuccessAction = DataSuccessAction<
    CustomerServicePlan | ClareDbCollection<CustomerServicePlan>
>;
type CustomerServicePlanFailureAction = DataErrorAction<
    CustomerServicePlan | ClareDbCollection<CustomerServicePlan>
>;
type CustomerServicePlanError = DataServiceError<
    CustomerServicePlan | ClareDbCollection<CustomerServicePlan>
>;

export class GetCustomerServicePlan implements CustomerServicePlanAction {
    readonly type = ActionTypes.getCustomerServicePlan;
    constructor(public readonly payload: number) {}
}

export class GetCustomerServicePlanSuccess implements CustomerServicePlanSuccessAction {
    readonly type = ActionTypes.getCustomerServicePlanSuccess;
    constructor(public readonly result: CustomerServicePlan) {}
}

export class GetCustomerServicePlanFailure implements CustomerServicePlanFailureAction {
    readonly type = ActionTypes.getCustomerServicePlanFailure;
    constructor(public readonly error: CustomerServicePlanError) {}
}

export type Actions =
    | GetCustomerServicePlan
    | GetCustomerServicePlanSuccess
    | GetCustomerServicePlanFailure;
